import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    lookupType: null,
    lookupTypes: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const lookupTypeReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.LOOKUPTYPE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.LOOKUPTYPE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.LOOKUPTYPE_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default lookupTypeReducer;
